import { useEffect, useMemo } from 'react';

import { Alert } from '../../../../../components/alert';

type BookErrorsMessageProps = {
  bookErrors: any[];
  alertVisible: boolean;
  setAlertVisible: (visible: boolean) => void;
};

export const BookErrorsMessage = ({
  alertVisible,
  setAlertVisible,
  bookErrors,
}: BookErrorsMessageProps) => {
  const bookErrorsMessage = useMemo(() => {
    if (!bookErrors?.length) return '';

    const messages: string[] = [];

    bookErrors.forEach((bookObj) => {
      Object.entries(bookObj).forEach(([bookName, errorsArray]) => {
        if (!Array.isArray(errorsArray) || errorsArray.length === 0) return;

        const errorsText = errorsArray
          .map((errItem) => {
            if (typeof errItem !== 'object' || errItem === null) {
              return String(errItem);
            }

            const lines = Object.entries(errItem).map(([key, value]) => `${key}: ${value}`);
            return lines.join('\n');
          })
          .join('\n');

        messages.push(`${bookName}: ${errorsText}`);
      });
    });

    return messages.join('\n\n');
  }, [bookErrors]);

  useEffect(() => {
    if (bookErrorsMessage && !alertVisible) {
      setAlertVisible(true);
    }
  }, [bookErrorsMessage]);

  if (!alertVisible || !bookErrorsMessage) return <></>;

  return (
    <Alert
      title="Something went wrong"
      message={bookErrorsMessage}
      onClose={() => setAlertVisible(false)}
    />
  );
};
